import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-slate-900 text-slate-500 py-12 text-center text-sm border-t border-slate-800" data-id="element-52">
      <div className="container mx-auto px-4" data-id="element-53">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-8" data-id="element-54">
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-slate-300 transition-colors underline decoration-slate-700 underline-offset-4 hover:decoration-slate-400" data-id="element-55">
            Política de Privacidad
          </button>
          <span className="hidden md:inline text-slate-700" data-id="element-56">•</span>
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-slate-300 transition-colors underline decoration-slate-700 underline-offset-4 hover:decoration-slate-400" data-id="element-57">
            Términos y Condiciones
          </button>
        </div>

        <p data-id="element-58">&copy; {new Date().getFullYear()} Todos los derechos reservados.</p>
        <p className="mt-2 max-w-2xl mx-auto" data-id="element-59">
          Este producto no garantiza resultados específicos. Los resultados
          pueden variar. Este sitio no es parte del sitio web de Facebook o
          Facebook Inc. Además, este sitio no está respaldado por Facebook de
          ninguna manera.
        </p>
      </div>

      {/* Privacy Modal */}
      <LegalModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-60">
        <div className="space-y-4 text-left" data-id="element-61">
          <p data-id="element-62">
            <strong data-id="element-63">
              Última actualización: {new Date().toLocaleDateString()}
            </strong>
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-64">
            1. Recopilación de Información
          </h3>
          <p data-id="element-65">
            Recopilamos información cuando usted se registra en nuestro sitio,
            realiza un pedido o se suscribe a nuestro boletín. La información
            recopilada incluye su nombre y dirección de correo electrónico.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-66">
            2. Uso de la Información
          </h3>
          <p data-id="element-67">
            Cualquier información que recopilamos de usted puede usarse para:
          </p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-68">
            <li data-id="element-69">
              Personalizar su experiencia y responder a sus necesidades
              individuales
            </li>
            <li data-id="element-70">Mejorar nuestro sitio web</li>
            <li data-id="element-71">Mejorar el servicio al cliente</li>
            <li data-id="element-72">Procesar transacciones</li>
            <li data-id="element-73">Enviar correos electrónicos periódicos</li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-74">
            3. Protección de la Información
          </h3>
          <p data-id="element-75">
            Implementamos una variedad de medidas de seguridad para mantener la
            seguridad de su información personal. Utilizamos encriptación de
            última generación para proteger la información confidencial
            transmitida en línea.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-76">
            4. Divulgación a Terceros
          </h3>
          <p data-id="element-77">
            No vendemos, intercambiamos ni transferimos a terceros su
            información de identificación personal. Esto no incluye a los
            terceros de confianza que nos asisten en la operación de nuestro
            sitio web, la realización de nuestro negocio o el servicio a usted,
            siempre que dichas partes acuerden mantener esta información
            confidencial.
          </p>
        </div>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-78">
        <div className="space-y-4 text-left" data-id="element-79">
          <p data-id="element-80">
            <strong data-id="element-81">
              Última actualización: {new Date().toLocaleDateString()}
            </strong>
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-82">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-83">
            Al acceder y utilizar este sitio web, usted acepta estar sujeto a
            estos términos y condiciones de uso, todas las leyes y regulaciones
            aplicables, y acepta que es responsable del cumplimiento de las
            leyes locales aplicables.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-84">
            2. Licencia de Uso
          </h3>
          <p data-id="element-85">
            Se concede permiso para descargar temporalmente una copia de los
            materiales (información o software) en el sitio web para
            visualización transitoria personal y no comercial únicamente. Esta
            es la concesión de una licencia, no una transferencia de título.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-86">
            3. Descargo de Responsabilidad
          </h3>
          <p data-id="element-87">
            Los materiales en el sitio web se proporcionan "tal cual". No
            ofrecemos garantías, expresas o implícitas, y por la presente
            renunciamos y negamos todas las demás garantías, incluidas, entre
            otras, las garantías implícitas o condiciones de comerciabilidad,
            idoneidad para un propósito particular o no infracción de la
            propiedad intelectual.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-88">
            4. Limitaciones
          </h3>
          <p data-id="element-89">
            En ningún caso nosotros o nuestros proveedores seremos responsables
            de ningún daño (incluidos, entre otros, daños por pérdida de datos o
            ganancias, o debido a la interrupción del negocio) que surjan del
            uso o la imposibilidad de usar los materiales en nuestro sitio web.
          </p>

          <h3 className="text-lg font-bold text-slate-900 mt-4" data-id="element-90">
            5. Revisiones y Erratas
          </h3>
          <p data-id="element-91">
            Los materiales que aparecen en el sitio web podrían incluir errores
            técnicos, tipográficos o fotográficos. No garantizamos que ninguno
            de los materiales en su sitio web sea preciso, completo o actual.
          </p>
        </div>
      </LegalModal>
    </footer>;
}